const state = {
    isChecking: false,
  };
  
  const mutations = {
  
  };
  
  const actions = {
  
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  
  